import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        lan: 'fi',
        config: null,
        defaultConfig: {
            anyLan: false,
            boxed: false,
            boxedWidth: null,
            boxedHeight: null,
            categories: null,
            headerSelector: 'header',
            initCheckedCategories: [],
            initLocation: {
                lat: 64.180715,
                lng: 25.803243
            },
            initZoom: 10,
            maxBounds: null,
            markersBaseUrl: process.env.VUE_APP_LOCATIONS_API_PATH + 'places',
            routesBaseUrl: process.env.VUE_APP_LOCATIONS_API_PATH + 'routes',
            markersUrl: process.env.VUE_APP_LOCATIONS_API_PATH + 'places?southWestLat={swLat}&southWestLng={swLng}&northEastLat={neLat}&northEastLng={neLng}',
            routesUrl: process.env.VUE_APP_LOCATIONS_API_PATH + 'routes?southWestLat={swLat}&southWestLng={swLng}&northEastLat={neLat}&northEastLng={neLng}',
            routesZoomThreshold: 9,
            settingsPanelClosed: false,
            setTopFromHeader: true,
            showCategoryFilters: true,
            showExternalFilters: true,
            showGeosearch: true,
            showMyLocationButton: true,
            showShareButtons: false,
            showTypeFilters: true,
            sourceIds: [],
            polylineOptions: {
                strokeColor: '#0099ff',
                strokeHoverColor: '#ff0099',
                strokeWeight: 5
            },
            overlayLayers: null,
            welcomeMessage: null,
            titleSeparator: ' - ',
            texts: {
                fi: {
                    articles: 'Artikkelit',
                    baseMaps: 'Taustakartat',
                    categories: 'Kategoriat',
                    close: 'Sulje',
                    demoModeText: '<p>Tervetuloa kartalle!</p><p>Tämä kartta on tehty <strong>KarttaMap Free</strong> -tilillä. KarttaMapin avulla luot verkkosivuillesi omia karttoja. Voi lisätä reittejä ja kohteita sekä linkittää niihin mielenkiintoisia sisältöjä. Miellyttävä käyttöliittymä ja GPS-paikannus pitävät käyttäjän kartalla.</p><p>Luo oma karttasi osoitteessa <a href="https://karttamap.com" target="_blank">karttamap.com</a>.</p>',
                    DepthContour_L: 'Syvyyskäyrät',
                    downloadGPX: 'Lataa GPX',
                    geonorge: 'Maastokartta (Norja)',
                    geosearchLabel: 'Etsi paikkaa',
                    lantmateriet: 'Maastokartta (Ruotsi)',
                    location: 'Sijainti',
                    mapSettings: 'Kartan asetukset',
                    mapZoom: 'Zoom',
                    marker: 'Kohde',
                    myLocationCenter: 'Keskitä kartta sijaintini mukaan',
                    myLocationShow: 'Näytä sijaintini',
                    'nls-basic-print-color-1-10000': 'Maastokartta (Suomi)',
                    NauticalChart: 'Merikartta (Suomi)',
                    openstreetmap: 'Open Street Map',
                    opentopomap: 'Open Topo Map',
                    overlayLayers: 'Karttatasot',
                    openLink: 'Avaa linkki',
                    readMore: 'Lue lisää',
                    route: 'Reitti',
                    routeLength: 'Reitin pituus',
                    services: 'Palvelut',
                    Sounding_P: 'Syvyyspisteet',
                    source: 'Lähde',
                    tagFiltersLegend: 'Kategoria',
                    toggleAll: 'Valitse kaikki',
                    typeFiltersLegend: 'Tyyppi',
                    visitWebPage: 'Vieraile sivustolla'
                },
                en: {
                    articles: 'Articles',
                    baseMaps: 'Base maps',
                    categories: 'Categories',
                    close: 'Close',
                    demoModeText: '<p>Welcome to the map!</p><p>This map is created with <strong>KarttaMap Free</strong> account. With KarttaMap you can create maps to your website. You can add routes and places and link interesting contents. Easy to use interface and GPS tracking keep users on the map.</p><p>Create your own map at <a href="https://karttamap.com" target="_blank">karttamap.com</a>.</p>',
                    DepthContour_L: 'Depth contours',
                    downloadGPX: 'Download GPX',
                    geonorge: 'Terrain map (Norway)',
                    geosearchLabel: 'Search places',
                    lantmateriet: 'Terrain map (Sweden)',
                    location: 'Location',
                    mapSettings: 'Map settings',
                    mapZoom: 'Zoom',
                    marker: 'Place',
                    myLocationCenter: 'Center map by my location',
                    myLocationShow: 'Show my location',
                    'nls-basic-print-color-1-10000': 'Terrain map (Finland)',
                    NauticalChart: 'Nautical chart (Finland)',
                    openstreetmap: 'Open Street Map',
                    opentopomap: 'Open Topo Map',
                    overlayLayers: 'Overlay layers',
                    openLink: 'Open link',
                    readMore: 'Read more',
                    route: 'Route',
                    routeLength: 'Route length',
                    services: 'Services',
                    Sounding_P: 'Depth sounding points',
                    source: 'Source',
                    tagFiltersLegend: 'Category',
                    toggleAll: 'Toggle all',
                    typeFiltersLegend: 'Type',
                    visitWebPage: 'Visit web page'
                }
            },
            userId: null
        },
        markers: [],
        routes: [],
        externalMarkers: {},
        externalRoutes: {},
        checkedCategories: [],
        checkedExternals: [],
        showMarkers: true,
        showRoutes: true,
        routesDisabled: false,
        gettingUserLocation: false,
        userLocation: null,
        followUser: false,
        fullscreen: false,
        settingsOpen: document.documentElement.clientWidth > 768,
        modal: null
    },
    mutations: {
        setLan(state, lan) {
            state.lan = lan;
        },
        setConfig(state, config) {
            //state.config = config;
            // Need to pass {} as the first for Object.assign to make it reactive
            state.config = Object.assign({}, state.defaultConfig, config);
            if (state.config.initCheckedCategories) {
                state.checkedCategories = state.config.initCheckedCategories;
            }
            /*if (state.config.overlayLayers) {
                let tmp = state.config.overlayLayers;
                state.config.overlayLayers = null;
                state.config.overlayLayers = tmp;
                tmp = null;
            }*/
        },
        setMaxBounds(state, bounds) {
            state.config.maxBounds = bounds;
            this.commit('setConfig', state.config);
        },
        setMarkers(state, markers) {
            state.markers = markers;
        },
        setRoutes(state, routes) {
            state.routes = routes;
        },
        setShowMarkers(state, toggle) {
            state.showMarkers = toggle;
            if (! toggle) {
                state.markers = [];
            }
        },
        setShowRoutes(state, toggle) {
            state.showRoutes = toggle;
            if (! toggle) {
                state.routes = [];
            }
        },
        setRoutesDisabled(state, routesDisabled) {
            state.routesDisabled = routesDisabled;
        },
        setExternalMarkers(state, payload) {
            // Have to use a temp var to store the markers
            // and set externalMarkers null first to trigger the change
            let temp = state.externalMarkers;
            temp[payload.name] = payload.markers;
            state.externalMarkers = null;
            state.externalMarkers = temp;
            temp = null;
        },
        removeExternalMarkers(state, name) {
            // Have to use a temp var to store the markers
            // and set externalMarkers null first to trigger the change
            let temp = state.externalMarkers;
            delete temp[name];
            state.externalMarkers = null;
            state.externalMarkers = temp;
            temp = null;
        },
        setExternalRoutes(state, payload) {
            // Have to use a temp var to store the routes
            // and set externalRoutes null first to trigger the change
            let temp = state.externalRoutes;
            temp[payload.name] = payload.routes;
            state.externalRoutes = null;
            state.externalRoutes = temp;
            temp = null;
        },
        setCheckedCategories(state, checkedCategories) {
            state.checkedCategories = checkedCategories;
        },
        setCheckedExternals(state, checkedExternals) {
            state.checkedExternals = checkedExternals;
            // Remove from externalMarkers if not checked
            for (const [key] of Object.entries(state.externalMarkers)) {
                if (! state.checkedExternals.includes(key)) {
                    // Have to use a temp var to store the markers
                    // and set externalMarkers null first to trigger the change
                    let temp = state.externalMarkers;
                    delete temp[key];
                    state.externalMarkers = null;
                    state.externalMarkers = temp;
                    temp = null;
                }
            }
        },
        addCheckedExternal(state, name) {
            // Add only if it doesn't exist already
            if (! state.checkedExternals.includes(name)) {
                state.checkedExternals.push(name);
            }
        },
        setOverlayLayers(state, overlayLayers) {
            state.config.overlayLayers = overlayLayers;
        },
        setGettingUserLocation(state, gettingUserLocation) {
            state.gettingUserLocation = gettingUserLocation;
        },
        setUserLocation(state, userLocation) {
            state.userLocation = userLocation;
        },
        setFollowUser(state, followUser) {
            state.followUser = followUser;
        },
        setFullscreen(state, fullscreen) {
            state.fullscreen = fullscreen;
        },
        setSettingsOpen(state, settingsOpen) {
            state.settingsOpen = settingsOpen;
        },
        toggleSettingsOpen(state) {
            state.settingsOpen = ! state.settingsOpen;
        },
        setModal(state, modal) {
            state.modal = modal;
        }
    },
    getters: {

    }
});
